import { Component, ViewEncapsulation, Input, Output, EventEmitter } from '@angular/core';
import { ResortComponent } from '../../../shared/resort.component';
import { ResortDetail, ResortInventory, ResortImage, ResortImageType, ResortImageFormat, } from '../../../models/presentation.model';
import { ApplicationConfiguration } from '../../../shared/core/ovs.core';
import { ResortInventoryGroup } from '../../../models/browser.model';
import { ResortApplication } from '../../../services/resort-application.service';
import { BaseRoomResult } from '../base-room-result.model';


@Component({
  selector: 'room-result-earn',
  templateUrl: './room-result-earn.component.html',
  styleUrls: ['./room-result-earn.component.scss'],
  encapsulation: ViewEncapsulation.None
})
export class RoomResultEarnComponent extends BaseRoomResult {
  @Input ()
  public results: ResortInventory[] = [];
  @Input ()
  public configuration: ApplicationConfiguration;
  @Input ()
  public group: ResortInventoryGroup;
  @Input ()
  public application: ResortApplication;
  @Input ()
  public resultType: string;
  @Output()
  public startBooking: EventEmitter<any> = new EventEmitter();

  constructor() {
    super();
   }
}



// WEBPACK FOOTER //
// /home/vsts/work/1/s/Ovs.Resort.UI.Web/src/app/resort-detail/room-availability/room-result-earn/room-result-earn.component.ts